import { Cookies } from 'react-cookie';

import { HubsOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHubsOnMap = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/hubs/floor/${slug}`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as HubsOnMapResponse;
};
